import { render, staticRenderFns } from "./OrbitRemoveProjectModal.vue?vue&type=template&id=7709082e"
import script from "./OrbitRemoveProjectModal.vue?vue&type=script&lang=ts"
export * from "./OrbitRemoveProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitRemoveProjectModal.vue?vue&type=style&index=0&id=7709082e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports